import * as types from '../mutation-types'

const state = {
  appId: '',
  appName: '',
  historyServices: []
}

const getters = {
  getAppId: state => state.appId,
  getAppName: state => state.appName,
  getHistoryServices: state => state.historyServices || [],
}


const actions = {
  setAppId ({ commit }, appId) {
    commit(types.SET_APPID, appId)
  },
  setAppName ({ commit }, appName) {
    commit(types.SET_APPNAME, appName)
  },
  setHistoryServices ({ commit }, historyServices) {
    commit(types.SET_HISTORY_SERVICES, historyServices)
  },
}


const mutations = {
  [types.SET_APPID] (state, appId) {
    state.appId = appId
  },
  [types.SET_APPNAME] (state, appName) {
    state.appName = appName
  },
  [types.SET_HISTORY_SERVICES] (state, historyServices) {
    state.historyServices = historyServices
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./app/store/modules/app.js